import api from "@/api/apiBriefing";
const briefing = {
    namespaced: true,
    state: () => ({
        briefingList : [],
        totalPages : 1,
        fetchStatus : 0,
        fetchError : null,
    }),
    mutations: {
      SET_BRIEFING_LIST(state,res){
        state.briefingList = res.results;
        state.totalPages = res.totalPages;
      },
      SET_FETCH_STATUS(state,res){
        state.fetchStatus = res;
      },
      SET_ERROR(state,error){
        state.fetchError = error;
      }
    },
    actions: {
        async uploadVideo({commit},formData) {
            try {
              const response = await api.uploadVideoApi(formData);
              if(response.error){
                commit("SET_ERROR",response.error);
              } else{
                commit("SET_ERROR",null);
              }
            } catch (error) {
              return;
            }
        },
        async updateVideo({commit},{formData,info}) {
          try {
            const response = await api.updateVideoApi(formData,info);
            if(response.error){
              commit("SET_ERROR",response.error);
            } else{
              commit("SET_ERROR",null);
            }
          } catch (error) {
            return;
          }
      },
        async getBriefingList({commit},info) {
            try {
              commit("SET_BRIEFING_LIST",{results:[],totalPages:1});
              const response = await api.getBriefingListApi(info);
              commit("SET_BRIEFING_LIST",response);
            } catch (error) {
              return;
            }
        },
    },
    getters: {
        briefingList: (state) => state.briefingList, 
      },
}

export default briefing;